import _ from 'lodash';

export const SET_SELECTED_CARD = 'SET_SELECTED_CARD';
export const SET_CLEAR_SELECTION = 'SET_CLEAR_SELECTION';
export const SET_HAS_MORE = 'SET_HAS_MORE';
export const SET_SEARCH = 'SET_SEARCH';

export const initialState = {
  selectedCards: {},
  hasMore: true,
  search: '',
};

const reducer = (state, action) => {
  switch (action.type) {
    case SET_SELECTED_CARD: {
      const { entity } = action.payload;

      const {
        id,
        videoUrl,
        searchableType,
        searchable: {
          tag: { name: tagName = '' } = {},
          entity: searchableEntity = {},
          charStart,
          charEnd,
        } = {},
      } = entity;

      const {
        text,
        transcriptText,
        note,
      } = searchableEntity;

      let content = note || text || transcriptText || entity.note || '';

      if (searchableType === 'TagHighlight') {
        content = content.slice(charStart, charEnd + 1);
      }

      const { selectedCards } = state;
      const cards = _.cloneDeep(selectedCards);

      if (cards[id]) {
        delete cards[id];
      } else {
        cards[id] = {
          id,
          videoUrl,
          content,
          tagName,
        };
      }

      return {
        ...state,
        selectedCards: cards,
      };
    }
    case SET_CLEAR_SELECTION: {
      return {
        ...state,
        selectedCards: {},
      };
    }
    case SET_HAS_MORE: {
      const { hasMore } = action.payload;
      return {
        ...state,
        hasMore,
      };
    }
    case SET_SEARCH: {
      const { search } = action.payload;
      return {
        ...state,
        search,
      };
    }
    default:
      return state;
  }
};

export default reducer;
